<template>
  <div id="add-candidate-form">
    <section class="mt-4" v-show="step == 1">
      <!--       <div class="row">
        <div class="col-12 col-lg-6 mt-4 ml-auto mr-auto mb-4">
          <div class="multisteps-form__progress">
            <button class="multisteps-form__progress-btn js-active" type="button" title="User Info">
              Step 1
            </button>
            <button class="multisteps-form__progress-btn" type="button" title="Address">
              Step 2
            </button>
            <button class="multisteps-form__progress-btn" type="button" title="Address">
              Step 3
            </button>
          </div>
        </div>
      </div> -->

      <div class="dropdown">
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          <li><a class="dropdown-item" href="#">Action</a></li>
          <li><a class="dropdown-item" href="#">Another action</a></li>
          <li><a class="dropdown-item" href="#">Something else here</a></li>
        </ul>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-11">
          <div class="row">
            <div class="form-group m-label col-md-6 required">
              <input
                @click="stepValidator"
                type="text"
                id="first_name"
                v-model.trim.lazy="$v.selectedFields.firstName.$model"
                class="form-control"
                :class="{
                  'is-invalid': $v.selectedFields.firstName.$error,
                  'is-valid': !$v.selectedFields.firstName.$invalid,
                }"
              />
              <label for="first_name">First name</label>
            </div>

            <div class="form-group m-label col-md-6 required">
              <input
                @change="stepValidator"
                type="text"
                id="last_name"
                v-model.trim.lazy="$v.selectedFields.lastName.$model"
                class="form-control"
                :class="{
                  'is-invalid': $v.selectedFields.lastName.$error,
                  'is-valid': !$v.selectedFields.lastName.$invalid,
                }"
              />
              <label for="last_name">Last name</label>
            </div>
          </div>

          <!-- 
             <div class="form-group m-label-left">
            <input
              :type="passwordType"
              class="form-control password-input"
              :class="{
                'is-invalid': $v.form.password.$error,
                'is-valid': !$v.form.password.$invalid,
              }"
              id="login-password"
              aria-label="Password"
              aria-describedby="passwordHelp"
              required
              v-model.trim.lazy="$v.form.password.$model"
              style="padding-left: 16px"
            />
            <label for="login-password">Password</label>
            <span>
              <i
                class="password-icon"
                :class="[passwordIcon]"
                @click="hidePassword = !hidePassword"
              ></i>
            </span>
          </div>

           -->

          <div class="form-group m-label-left isWidth required-fixed-right">
            <input
              id="email"
              type="email"
              @input="stepValidator"
              @blur="checkEmailExist($event)"
              class="form-control"
              :class="{
                'is-invalid': $v.selectedFields.email.$error,
                'is-valid': !$v.selectedFields.email.$invalid,
              }"
              v-model.trim="$v.selectedFields.email.$model"
            />
            <label for="email">Email Address</label>
            <span class="placeholder-email">
              <a @click="handlePlaceholderEmail" class="badge bg-success btn-placeholder-email"
                >temporary email</a
              >
            </span>
          </div>

          <section>
            <form ref="addCandidateFileForm">
              <div class="dropzone p-4">
                <div class="dropzone-message file-drag-drop">
                  <p class="small drop-files">Upload document here or click to browse for file.</p>

                  <label for="file" class="btn btn-primary btn-sm file-upload-label mb-0"
                    >Browse</label
                  >
                  <input
                    type="file"
                    id="file"
                    ref="addCandidateFiles"
                    @change="handleFileUpload"
                    class="file-upload-input"
                    accept=".doc,.docx,.pdf,.odt"
                    multiple
                  />

                  <ul class="list-group file-listing mt-3">
                    <li
                      v-for="(file, key) in addCandidateFormFiles"
                      :key="key"
                      class="list-group-item d-flex align-items-center small"
                    >
                      <span class="mr-3">
                        <i
                          ref="primaryIcon"
                          :title="
                            itemId == key
                              ? 'Primary CV'
                              : 'Click here to make this document primary'
                          "
                          @click="setAsDefault($event)"
                          :id="key"
                          :class="['fas fa-crown', itemId == key ? 'crown-active' : '']"
                        ></i>
                      </span>

                      <span class="mr-auto">{{ file.name }}</span>
                      <span class="badge badge-primary badge-pill ml-auto">{{
                        `${(file.size / 1024 / 1024).toFixed(2)} MB`
                      }}</span>
                      <span class="remove-container ml-4">
                        <span class="remove" v-on:click="removeFile(key)">×</span>
                      </span>
                    </li>
                  </ul>

                  <progress v-if="isUploading" max="100" :value.prop="uploadPercentage"></progress>
                  <div v-if="isUploading && uploadPercentage < 100" class="small">
                    {{ `${uploadPercentage}%` }}
                  </div>
                </div>
              </div>
            </form>
          </section>

          <!-- Validation Error Messages -->
          <!--  <div
            v-if="!$v.selectedFields.firstName.required"
            class="alert alert-danger text-center"
            role="alert"
          ></div> -->
          <!-- End Validation Error Messages -->

          <!-- VALIDATION MESSAGES -->
          <Message v-show="errorMessage" class="mt-2 text-center" type="error-alert">
            <p slot="alert-message" class="mb-0" style="font-weight: 700">{{ errorMessage }}</p>
          </Message>

          <div v-if="$v.selectedFields.firstName.$error">
            <div
              v-if="!$v.selectedFields.firstName.required"
              class="alert alert-danger text-center"
              role="alert"
            >
              <!-- {{ errorHandler($v.selectedFields.firstName.$error) }} -->
              First Name field is required.
            </div>
          </div>
          <div v-if="$v.selectedFields.lastName.$error">
            <div
              v-if="!$v.selectedFields.lastName.required"
              class="alert alert-danger text-center"
              role="alert"
            >
              Last Name field is required.
            </div>
          </div>
          <div v-if="$v.selectedFields.email.$error">
            <div
              v-if="!$v.selectedFields.email.required"
              class="alert alert-danger text-center"
              role="alert"
            >
              Email field is required.
            </div>
          </div>
          <div v-if="$v.selectedFields.email.$error">
            <div
              v-if="!$v.selectedFields.email.email"
              class="alert alert-danger text-center"
              role="alert"
            >
              This is not valid email.
            </div>
          </div>
          <div v-if="$v.selectedFields.cityId.$error">
            <div
              v-if="!$v.selectedFields.cityId.required"
              class="alert alert-danger text-center"
              role="alert"
            >
              City field is required.
            </div>
          </div>
          <div v-if="$v.selectedFields.countryId.$error">
            <div
              v-if="!$v.selectedFields.countryId.required"
              class="alert alert-danger text-center"
              role="alert"
            >
              Country field is required.
            </div>
          </div>
          <!-- END VALIDATION MESSAGES -->
        </div>
      </div>
    </section>

    <section class="mt-4" v-show="step == 2">
      <!--       <div class="row">
        <div class="col-12 col-lg-6 mt-4 ml-auto mr-auto mb-5">
          <div class="multisteps-form__progress">
            <button class="multisteps-form__progress-btn" type="button" title="User Info">
              Step 1
            </button>
            <button class="multisteps-form__progress-btn js-active" type="button" title="Address">
              Step 2
            </button>
            <button class="multisteps-form__progress-btn" type="button" title="Address">
              Step 3
            </button>
          </div>
        </div>
      </div> -->

      <!-- <div style="padding: 0 34px 0 34px">
        
      </div> -->
      <div class="row justify-content-center">
        <div class="col-md-11">
          <div class="form-group m-label-left isWidth">
            <input
              type="url"
              id="linkedin"
              v-model="selectedFields.linkedin"
              class="form-control"
            />
            <label for="linkedin">LinkedIn</label>
          </div>

          <div class="form-group m-label-left isWidth">
            <input id="webpage" type="url" v-model="selectedFields.webpage" class="form-control" />
            <label for="webpage">Webpage</label>
          </div>

          <div class="row justify-content-center">
            <div class="form-group m-label filter-item col-md-5 no-hor">
              <v-select
                id="country-code"
                v-model="selectedFields.countrycode"
                :options="[...getAllCountries].map(item => `${item.phone_code} ${item.name}`)"
                :clearable="false"
                @input="addCountryCode(selectedFields.countrycode)"
              >
                <template v-slot:option="option">
                  {{ option.label }}
                </template>
              </v-select>
              <label for="country-code">Country Code</label>
            </div>

            <div class="form-group m-label col-md-7">
              <input
                type="tel"
                class="form-control"
                v-model="selectedFields.phone"
                id="phone-number"
              />
              <label for="phone-number">Phone number</label>
            </div>
          </div>

          <div class="form-group m-label-left isWidth">
            <input
              type="text"
              id="street-address"
              v-model="selectedFields.address"
              class="form-control"
              autocomplete="off"
            />
            <label for="street-address">Street address</label>
          </div>

          <div class="row">
            <div class="form-group m-label col-md-4">
              <input
                type="text"
                id="postal-code"
                v-model="postalInput"
                class="form-control"
                @input="searchForCityByPostal"
                autocomplete="off"
              />
              <label for="postal-code">Postal code</label>
            </div>

            <div class="form-group filter-item m-label col-md-8 required-fixed-drop">
              <v-select
                :class="{
                  'is-invalid': $v.selectedCity.$error,
                  'is-valid': !$v.selectedCity.$invalid,
                }"
                id="city"
                v-model.trim.lazy="$v.selectedCity.$model"
                @input="stepValidator"
                label="name"
                :options="getCitiesListByCountry"
                :reduce="city => city"
                :clearable="true"
                placeholder="City"
              >
                <template v-slot:no-options>
                  <div style="opacity: 0.5">Please select a country first</div>
                </template>
              </v-select>
              <label for="city">City</label>
            </div>
          </div>
          <div class="form-group filter-item m-label-left required-fixed-right-even">
            <div
              :class="{
                'is-invalid': $v.selectedCountry.$error,
                'is-valid': !$v.selectedCountry.$invalid,
              }"
            >
              <v-select
                v-model.trim.lazy="$v.selectedCountry.$model"
                @input="
                  fetchCitiesByCountryId($event);
                  stepValidator();
                "
                :options="getAllCountries"
                label="name"
                :reduce="country => country"
                :clearable="true"
                placeholder="Country"
              >
                <template v-slot:no-options>
                  <div style="opacity: 0.5">Sorry, no matching country</div>
                </template>
              </v-select>
            </div>
            <label for="country">Country</label>
          </div>
        </div>
      </div>
    </section>

    <section v-show="step == 3">
      <div class="row">
        <div class="col-12 col-lg-6 mt-4 ml-auto mr-auto mb-5">
          <div class="multisteps-form__progress">
            <button class="multisteps-form__progress-btn" type="button" title="User Info">
              Step 1
            </button>
            <button class="multisteps-form__progress-btn" type="button" title="Address">
              Step 2
            </button>
            <button class="multisteps-form__progress-btn js-active" type="button" title="Address">
              Step 3
            </button>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-11 mt-4">
          <Message v-show="errorMessage" class="mt-2" type="error-alert">
            <p slot="alert-message" class="mb-0">{{ errorMessage }}</p>
          </Message>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-md-11">
          <div class="form-group m-label-left filter-item">
            <v-select
              id="competences"
              v-model="selectedFields.competences"
              label="name"
              :options="getCompetencesFilterList"
              :reduce="competence => competence.id"
              :clearable="true"
              multiple
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching && search.length >= 3">
                  No results found for <em>{{ search }}</em
                  >.
                </template>
                <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
              </template>
            </v-select>
            <label for="competences">Competencies</label>
          </div>

          <div class="form-group m-label-left filter-item">
            <v-select
              v-model="selectedFields.languages"
              id="langs"
              label="name"
              :options="getLanguagesList"
              :reduce="lang => lang.id"
              :clearable="true"
              multiple
            >
              <template v-slot:no-options="{}">
                <div style="opacity: 0.5">No languages found!</div>
              </template>
            </v-select>
            <label for="langs">Languages</label>
          </div>

          <div class="form-group m-label-left isWidth required-fixed-right-even">
            <select
              style="padding-left: 18px"
              v-model="selectedFields.relocation"
              class="has-floating-label form-select my-3 w-100"
              id="relocation"
            >
              <option disabled selected>Relocation</option>
              <option :value="1">Yes</option>
              <option :value="0">No</option>
            </select>
            <label for="relocation">Relocation</label>
          </div>

          <div class="form-group m-label-left isWidth required-fixed-right-even">
            <select
              style="padding-left: 18px"
              v-model="selectedFields.employmentType"
              class="has-floating-label form-select my-3 w-100"
              id="Employment-type"
            >
              <option value="1">Employment</option>
              <option value="2">Self-employment</option>
              <option value="3">Employment / Self-Employment</option>
            </select>
            <label for="Employment-type">Employment</label>
          </div>

          <div class="form-group m-label-left isWidth required-fixed-right-even">
            <select
              style="padding-left: 18px"
              v-model="selectedSource"
              @change="stepValidator"
              class="has-floating-label form-select my-3 w-100"
            >
              <option v-for="source in getSourceList" :key="source.sourceid" :value="source">
                {{ source.description }} ({{ source.source_name }})
              </option>
            </select>
            <label for="source">Source</label>
          </div>
        </div>
      </div>
    </section>

    <!-- Nav btn's -->
    <div class="row justify-content-center mb-5 mt-4">
      <div class="col-6 text-center">
        <button
          class="btn btn-primary btn-custom w-50 mr-5 prev"
          @click="
            prev();
            stepValidator();
          "
          :disabled="step == 1 || step < 0"
        >
          <i class="fa fa-chevron-left mr-3"></i> Back
        </button>
      </div>
      <div class="col-6 text-center">
        <button
          v-if="step == 3"
          @click="saveCandidate"
          :disabled="isNextDisabled"
          type="submit"
          form="add-for-job"
          class="btn btn-success btn-custom w-50 mr-2"
        >
          Add
        </button>

        <button
          v-else
          type="submit"
          form="add-for-job"
          class="btn btn-secondary btn-custom w-50"
          @click="next"
          :disabled="isNextDisabled"
        >
          Next
          <i class="fa fa-chevron-right ml-3"></i>
        </button>
      </div>
    </div>
    <Spinner :isLoading="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { required, minLength, email } from 'vuelidate/lib/validators';
import { selectDefaultDocument } from '../../../mixins/selectDefaultDocumentMixin';
import { errorService } from '../../../services/errorService';
import Spinner from '../../common/LoadingSpinner/Spinner';
import Message from '../../AlertMessages/Message';
import { MESSAGES } from '../../../constants';
// import axios from 'axios';

const MAX_FILE_SIZE = 20;

export default {
  components: { Message, Spinner },
  mixins: [selectDefaultDocument],
  props: {
    job_uuid: String,
  },
  data: () => ({
    selectedSource: {},
    debouncePostalInput: '',
    timeout: null,
    dragAndDropCapable: false,
    uploadPercentage: 10,
    isUploading: false,
    isPrimary: true,
    primaryCv: true,
    file: '',
    formDataObject: new FormData(),
    addCandidateFormFiles: [],
    isAnyError: false,
    isNextDisabled: true,
    errorMessage: '',
    citiesByNameOptions: [],
    /*  countriesByNameOptions: [], */
    isLabelActive: false,
    step: 1,
    isLoading: false,
    languagesOptions: [],
    competencesOptions: [],
    selectedFields: {
      /* Step 1 */
      firstName: '',
      lastName: '',
      email: '',
      countrycode: '',
      countryId: null,
      countryName: '',
      cityName: '',
      phone: '',
      address: '',
      postal: '',
      cityId: null,
      /* Step 2 */
      linkedin: '',
      webpage: '',
      competences: [],
      languages: [],
      uploadedCvFile: '',
      /* Step 3 */
      relocation: 0,
      employmentType: 1,
      source: {},

      /* sendLogonCredentials: false, */
    },
    selectedCountry: {},
    selectedCity: {},
  }),
  validations: {
    selectedFields: {
      firstName: {
        required,
        minLength: minLength(2),
      },
      lastName: {
        required,
        minLength: minLength(2),
      },
      email: {
        required,
        email,
      },
      cityId: {
        required,
      },
      countryId: {
        required,
      },
      countryName: {
        required,
      },
    },
    selectedCountry: {
      required,
    },
    selectedCity: {
      required,
    },
  },
  methods: {
    ...mapActions([
      'retrieveCityByPostalAndCoutryId',
      'retrieveCitiesListByCountryId',
      'retrieveCompetencesList',
      'retrieveAllCountries',
      'searchLocationByName',
      'retrieveSourcesList',
      'checkIfEmailExist',
      'addCandidate',
      'retrieveFakeEmail',
    ]),
    handlePlaceholderEmail() {
      this.retrieveFakeEmail().then(() => {
        this.selectedFields.email = this.getFakeEmail;
      });
    },
    addCountryCode(code) {
      this.selectedFields.countrycode = code.replace(/[0-9+]/g, '');
      this.selectedFields.phone = code.substring(0, code.indexOf(' ')) + ' ';
    },
    setDefaultCity() {
      const city = JSON.parse(localStorage.getItem('addCandidateModalData'));

      return {
        id: city.id,
        name: city.city,
      };
    },
    checkEmailExist(e) {
      this.checkIfEmailExist(e.target.value).then(() => {
        if (this.getIsEmailExist) {
          this.$toasted.error(MESSAGES.emailAlreadyBeenTaken, {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        }
      });
      /* .catch(err => {
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        }); */
    },
    stepValidator() {
      if (this.step === 1) {
        if (
          this.$v.selectedFields.email.$invalid === true ||
          this.$v.selectedFields.firstName.$invalid === true ||
          this.$v.selectedFields.lastName.$invalid === true
        ) {
          this.isNextDisabled = true;
        } else {
          this.isNextDisabled = false;
        }
      }

      if (this.step === 2) {
        if (this.$v.selectedCity.$model.name && this.$v.selectedCountry.$model.name) {
          this.isNextDisabled = false;
        } else {
          this.isNextDisabled = true;
        }
      }

      if (this.step === 3) {
        if (this.selectedSource.id) {
          this.isNextDisabled = false;
        } else {
          this.isNextDisabled = true;
        }
      }
    },
    /* File Upload Form */
    handleFileUpload() {
      const uploadedFiles = this.$refs['addCandidateFiles'].files;

      for (let i = 0; i < uploadedFiles.length; i++) {
        this.addCandidateFormFiles.push(uploadedFiles[i]);
      }

      this.$refs.addCandidateFileForm.reset();

      for (let i = 0; i < this.addCandidateFormFiles.length; i++) {
        const file = this.addCandidateFormFiles[i];

        const fileSize = (file.size / 1024 / 1024).toFixed(2);

        if (fileSize > MAX_FILE_SIZE) {
          this.errorMessage = `The file size exceeds the limit of ${MAX_FILE_SIZE} MB.`;
        }
      }

      const formData = new FormData();

      for (let i = 0; i < this.addCandidateFormFiles.length; i++) {
        const file = this.addCandidateFormFiles[i];

        const fileSize = (file.size / 1024 / 1024).toFixed(2);

        if (fileSize > MAX_FILE_SIZE) {
          this.errorMessage = `The file size exceeds the limit of ${MAX_FILE_SIZE} MB.`;
        } else {
          formData.append(`file_${i}`, file);
          formData.append(`primary_${i}`, this.isPrimary);
        }
      }

      formData.append('files_count', this.addCandidateFormFiles.length);

      this.formDataObject = formData;
    },
    removeFile(fileId) {
      this.addCandidateFormFiles.splice(fileId, 1);
    },
    cancelUpload() {
      this.addCandidateFormFiles = [];
      this.$emit('close');
    },
    determineDragAndDropCapable() {
      const div = document.createElement('div');
      return (
        ('draggable' in div || ('ondragstart' in div && 'ondrop' in div)) &&
        'FormData' in window &&
        'FileReader' in window
      );
    },
    submitFiles() {
      this.isUploading = true;

      const formData = new FormData();

      for (let i = 0; i < this.addCandidateFormFiles.length; i++) {
        const file = this.addCandidateFormFiles[i];

        const fileSize = (file.size / 1024 / 1024).toFixed(2);

        if (fileSize > MAX_FILE_SIZE) {
          this.errorMessage = `The file size exceeds the limit of ${MAX_FILE_SIZE} MB.`;
        } else {
          this.$refs.primaryIcon[i].classList.contains('crown-active')
            ? (this.isPrimary = true)
            : (this.isPrimary = false);

          formData.append(`file_${i}`, file);
          formData.append(`primary_${i}`, this.isPrimary);
        }
      }

      formData.append('files_count', this.addCandidateFormFiles.length);

      this.formDataObject = formData;
    },
    /* End File Upload Form */

    fetchCitiesByCountryId(e) {
      const countryID = e.id;
      this.retrieveCitiesListByCountryId({ id: countryID }).then(() => {
        this.selectedCity = {};
      });
    },
    fetchCitiesByCountryIdOnMount(e) {
      const countryID = e.id;
      this.retrieveCitiesListByCountryId({ id: countryID }).then(() => {});
    },
    saveCandidate() {
      this.isLoading = true;

      const jobadID = this.job_uuid ? { jobad_id: this.job_uuid } : {};

      this.addCandidate({
        first_name: this.selectedFields.firstName,
        last_name: this.selectedFields.lastName,
        email: this.selectedFields.email,
        country_code: this.selectedFields.countrycode,
        phone_number: this.selectedFields.phone,
        street: this.selectedFields.address,
        postal: this.selectedFields.postal,
        city_id: this.selectedCity.id,
        country_id: this.selectedCountry.id,
        linkedin: this.selectedFields.linkedin,
        webpage: this.selectedFields.webpage,
        competences: this.selectedFields.competences,
        languages: this.selectedFields.languages,
        files_count: this.addCandidateFormFiles.length,
        file: this.formDataObject,
        relocation: this.selectedFields.relocation,
        employment_type: this.selectedFields.employmentType,
        source_uuid: this.selectedSource.id,
        ...jobadID,
      })
        .then(res => {
          this.errorMessage = '';
          this.isLoading = false;

          this.$emit('close');
          this.$router.push({ name: 'candidate_id', params: { candidate_id: res.data.id } });
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-unlock-alt',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    onLanguageSearch(search, loading) {
      if (search.length >= 3) {
        loading(true);
        this.languagesOptions = this.getLanguagesList;
      }

      loading(false);
    },
    next() {
      this.step++;
      this.isNextDisabled = true;
    },
    prev() {
      this.step--;
    },

    searchForCityByPostal(val) {
      this.retrieveCityByPostalAndCoutryId({
        country_id: val.countryId,
        postalcode: val.postal,
      })
        .then(response => {
          this.isLoading = false;

          let result = Array.isArray(response.data);

          if (!result) {
            this.cityId = response.data.city_id;
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  computed: {
    ...mapGetters([
      'getCompetencesFilterList',
      'getCitiesListByCountry',
      'getLanguagesList',
      'getAllCountries',
      'getIsEmailExist',
      'getSourceList',
      'getToken',
      'getFakeEmail',
    ]),
    postalInput: {
      get() {
        return this.selectedFields.postal;
      },
      set(val) {
        if (this.timeout) clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.selectedFields.postal = val;
        }, 800);
      },
    },
  },
  watch: {
    selectedCountry(newSelectedCountry) {
      localStorage.addCandidateModalDataSelectedCountry = JSON.stringify(newSelectedCountry);
    },
    selectedCity(newSelectedCity) {
      localStorage.addCandidateModalDataSelectedCity = JSON.stringify(newSelectedCity);
    },
  },
  updated() {
    this.stepValidator();
  },
  mounted() {
    if (localStorage.addCandidateModalDataSelectedCountry) {
      const selectedCountry = JSON.parse(localStorage.addCandidateModalDataSelectedCountry);
      this.selectedCountry = selectedCountry;
      if (this.selectedCountry.id) {
        this.fetchCitiesByCountryIdOnMount(this.selectedCountry);
      }
    }

    if (localStorage.addCandidateModalDataSelectedCity) {
      const selectedCity = JSON.parse(localStorage.addCandidateModalDataSelectedCity);
      this.selectedCity = selectedCity;
    }

    this.dragAndDropCapable = this.determineDragAndDropCapable();
    this.$nextTick(() => {
      if (this.dragAndDropCapable) {
        ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(
          event => {
            this.$refs.addCandidateFileForm.addEventListener(
              event,
              e => {
                e.preventDefault();
                e.stopPropagation();
              },
              false,
            );
          },
        );

        this.$refs.addCandidateFileForm.addEventListener('drop', e => {
          for (let i = 0; i < e.dataTransfer.files.length; i++) {
            if (this.addCandidateFormFiles.length >= 1) {
              this.isPrimary = false;
            }

            this.addCandidateFormFiles.push({
              name: e.dataTransfer.files[i].name,
              primary: this.isPrimary,
              size: e.dataTransfer.files[i].size,
            });
          }
        });
      }
    });

    // this.retrieveAllCountries();
    // this.retrieveLanguagesList();
    this.retrieveCompetencesList();
    this.retrieveSourcesList().then(({ data }) => {
      this.selectedSource = data[0];
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables';
@import '@/assets/scss/_mixins';

/* Default select doc icon */
@include select-default-document-icon-styles;

.placeholder-email {
  position: absolute;
  right: 0.5rem;
  top: 1rem;
}

.btn-placeholder-email {
  cursor: pointer;
}

.btn-placeholder-email:hover {
  color: $color-white;
}

/* Upload Files */
.remove-container {
  .remove {
    cursor: pointer;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: 0.6;
  }

  .remove:hover {
    color: $color-status-closed;
  }
}

/* TODO:: use bootstrap utility instead of this */
progress[value] {
  /* Reset the default appearance */
  -webkit-appearance: none;
  appearance: none;

  width: 400px;
  height: 5px;
}

progress[value]::-webkit-progress-bar {
  background-color: #eee;
  border-radius: 2px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset;
}

progress[value]::-webkit-progress-value {
  background-color: $color-orange;

  border-radius: 2px;

  -webkit-animation: animate-stripes 5s linear infinite;
  animation: animate-stripes 5s linear infinite;
}

@-webkit-keyframes animate-stripes {
  100% {
    background-position: -100px 0px;
  }
}

@keyframes animate-stripes {
  100% {
    background-position: -100px 0px;
  }
}
/* End Upload Files */

/* Multi Step Form CSS */
.multisteps-form__progress {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
}

.multisteps-form__progress-btn {
  transition-property: all;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  transition-delay: 0s;
  position: relative;
  padding-top: 20px;
  color: rgba(108, 117, 125, 0.7);
  text-indent: -9999px;
  border: none;
  background-color: transparent;
  outline: none !important;
  cursor: pointer;
}

.no-padding {
  padding-left: 8px;
  padding-top: 15px;
}

.form-control {
  height: 3rem;
  line-height: 1.3;
  padding-left: 15px;
}

.form-group.required-fixed-right-even {
  position: relative;
  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 10px;
    color: red;
    opacity: 0.6;
  }
}
@media (min-width: 500px) {
  .multisteps-form__progress-btn {
    text-indent: 0;
  }
}

.multisteps-form__progress-btn:before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 13px;
  height: 13px;
  content: '';
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  transition: all 0.15s linear 0s, -webkit-transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  transition: all 0.15s linear 0s, transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  transition: all 0.15s linear 0s, transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s,
    -webkit-transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  border: 2px solid currentColor;
  border-radius: 50%;
  background-color: #fff;
  box-sizing: border-box;
  z-index: 3;
}

.multisteps-form__progress-btn:after {
  position: absolute;
  top: 5px;
  left: calc(-50% - 13px / 2);
  transition-property: all;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  transition-delay: 0s;
  display: block;
  width: 100%;
  height: 2px;
  content: '';
  background-color: currentColor;
  z-index: 1;
}

.multisteps-form__progress-btn:first-child:after {
  display: none;
}

.multisteps-form__progress-btn.js-active {
  color: #0088cc;
}

.multisteps-form__progress-btn.js-active:before {
  -webkit-transform: translateX(-50%) scale(1.2);
  transform: translateX(-50%) scale(1.2);
  background-color: currentColor;
}

.form-group.required {
  position: relative;
  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 21px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-fixed-right {
  position: relative;
  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 6px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-fixed-drop {
  position: relative;
  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 25px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-fixed-country {
  position: relative;
  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 8px;
    color: red;
    opacity: 0.6;
  }
}
</style>
